import { socketio } from "api"
import { portalSocket } from "./portalSocket"

export type Action = socketio.SocketIoMessageData<"userTrackingSubmitAction">

class UserTrackingSocket {
	readonly #buffer = new Array<() => void>()

	#useBuffer = true

	constructor() {
		portalSocket.onAuthenticated.addListener(() => {
			this.#useBuffer = false
			this.#flushBuffer()
		})
		portalSocket.onDeAuthenticated.addListener(() => {
			this.#useBuffer = true
		})
	}

	submitAction(action: Action) {
		const fn = () => portalSocket.sendMessage("userTrackingSubmitAction", action)
		if (this.#useBuffer) {
			this.#buffer.push(fn)
		} else {
			fn()
		}
	}

	#flushBuffer() {
		this.#useBuffer = false
		while (true) {
			const action = this.#buffer.pop()
			if (action == undefined) {
				break
			}
			action?.()
		}
	}
}

export const userTrackingSocket = new UserTrackingSocket()

export const submitTrackedAction = (action: string) => {
	userTrackingSocket.submitAction({ action })
}
